module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/qb/qb.component.css
// module id = ./src/app/qb/qb.component.css
// module chunks = main